exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".img[data-v-23b5ff3c]{max-width:220px;margin-left:auto;margin-right:auto}", "", {"version":3,"sources":["/app/src/components/login/Login.vue"],"names":[],"mappings":"AACA,sBACE,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACpB","file":"Login.vue","sourcesContent":["\n.img[data-v-23b5ff3c] {\n  max-width: 220px;\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23b5ff3c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login/Login.vue
// module id = 461
// module chunks = 10